/**
 * Cell renderers for paper-journal row tables (full values, no truncation).
 */

import React from 'react';
import styles from './paperJournalTableCells.module.scss';

function _dash(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

export function PaperJournalTextCell({
  value,
  wrap = false,
}: {
  value: string | null | undefined;
  wrap?: boolean;
}): React.ReactElement {
  const text = _dash(value);
  if (text === '—') {
    return <span>{text}</span>;
  }
  return (
    <span className={wrap ? styles.wrap : undefined} title={text}>
      {text}
    </span>
  );
}

export function PaperJournalMonoCell({
  value,
}: {
  value: string | null | undefined;
}): React.ReactElement {
  const text = _dash(value);
  if (text === '—') {
    return <span>{text}</span>;
  }
  return (
    <span className={styles.mono} title={text}>
      {text}
    </span>
  );
}

export function formatPaperJournalTimestamp(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return iso;
  }
  return d.toLocaleString();
}
